/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LaunchSecondPhaseLTIDataParser = 
/* #__PURE__ */ parsers.object([['blobId', codecString, 'blob_id']]);
export class LaunchSecondPhaseLTIData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LaunchSecondPhaseLTIDataParser.decode(input).map(res => new LaunchSecondPhaseLTIData(res));
    }
    static unsafeDecode(input) {
        return LaunchSecondPhaseLTIData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LaunchSecondPhaseLTIDataParser.encode(data);
    }
    static schema() {
        return LaunchSecondPhaseLTIDataParser.schema();
    }
}
